import { useState, useEffect } from 'react';
import { getRecaptchaRequired } from '../store/api/auth-api';

export function useRecaptchaRequired(page: 'login' | 'register') {
  const [recaptchaRequired, setRecaptchaRequired] = useState(false);

  useEffect(() => {
    getRecaptchaRequired(page)
      .then((recaptchaResult) => {
        setRecaptchaRequired(recaptchaResult.required);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  }, [page]);

  return {
    recaptchaRequired,
    setRecaptchaRequired,
  };
}
